/**
 *
 */
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  // 定义状态
  state: {
    showLeftMenu: false,
    showbg: false, //背景图片
    showhead: false,
    menuactive: 0,
    userInfo: {},
    baseData: [],
  },
  mutations: {
    setUserInfo(state, info) {
      state.userInfo = info;
    },
    setBaseData(state, info) {
      state.baseData = info;
    },
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/vuex/store.js